var map = {
	"./add_shopping_cart_40px.png": "fd61",
	"./automation_40px.png": "1622",
	"./cash_register_40px.png": "3cde",
	"./chart_40px.png": "4d84",
	"./clinic_52px.png": "e1ac",
	"./combo_chart_52px.png": "644a",
	"./headset_40px.png": "7432",
	"./icons8_buying_40px.png": "5595",
	"./icons8_cutlery_48px.png": "4049",
	"./icons8_inventory_flow_40px.png": "023a",
	"./icons8_motorbike_helmet_40px.png": "7192",
	"./icons8_motorbike_helmet_40px_1.png": "6e00",
	"./icons8_restaurant_menu_48px.png": "ee13",
	"./icons8_restaurant_menu_96px.png": "ad35",
	"./icons8_table_48px.png": "e676",
	"./icons8_table_top_view_48px.png": "808c",
	"./icons8_table_top_view_96px.png": "fac0",
	"./icons8_trolley_40px.png": "6db8",
	"./ifoodLogox40.png": "ab3d",
	"./medical_doctor_40px.png": "6f7c",
	"./medical_doctor_52px.png": "a396",
	"./motorcycle_delivery_multiple_boxes_40px.png": "27b6",
	"./sales_performance_40px.png": "bf80",
	"./services_52px.png": "a5ac",
	"./shutdown_40px.png": "46d5",
	"./stethoscope_52px.png": "27cd",
	"./table_50px.png": "e018",
	"./technical_support_52px.png": "8bea",
	"./today_52px.png": "6271",
	"./user_account_40px.png": "df3a",
	"./user_account_52px.png": "acf0",
	"./wheelchair_40px.png": "056d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec12";